const STABLE_ID_COOKIE_NAME = 'stableId';
const COOKIE_MAX_AGE = 365 * 24 * 60 * 60; // 1 year in seconds



export function setStableId(stableId: string) {
  // Set cookie with path=/ to make it available across all routes
  document.cookie = `${STABLE_ID_COOKIE_NAME}=${stableId}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`;
}

export function getStableId(): string | null {
  if (typeof document === 'undefined') return null;
  
  const name = STABLE_ID_COOKIE_NAME + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    if (!c) continue;
    
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}
